import { FIELDS } from '@/pages/Parts/constants';


const alternativesFields = [
  // { key: 'selected', label: '', sortable: false },
  // 'partNumber',
  // 'description',
  // 'mfr',
  // 'nsnNumber',
  // 'altNumber',
  // 'harmonizedCode',
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    field: FIELDS.PART_NUMBER,
    title: 'Part number',
  },
  {
    field: FIELDS.DESCRIPTION,
    title: 'Description',
  },
  {
    field: 'mfgName',
    title: 'Mfr',
  },
  {
    field: 'nsnNumber',
    title: 'NSN number',
  },
  {
    field: 'altMfr',
    title: 'Alt number',
  },
  {
    field: 'harmonizedCode',
    title: 'Harmonized Code',
  },
];

export default alternativesFields;
